/** 検証用。画面説明の吹き出し色 */
export const TOUR_TONES = [
  {
    id: 'slate',
    label: '濃いグレー',
    swatch: '#1e293b',
  },
  {
    id: 'blue',
    label: '青',
    swatch: '#1d4ed8',
  },
  {
    id: 'violet',
    label: '紫',
    swatch: '#6d28d9',
  },
  {
    id: 'coral',
    label: 'コーラル',
    swatch: '#be123c',
  },
  {
    id: 'teal',
    label: 'ティール',
    swatch: '#0f766e',
  },
  {
    id: 'gradient',
    label: 'グラデーション',
    swatch: 'linear-gradient(90deg, #0f766e 0%, #0284c7 100%)',
  },
] as const

export type TourToneId = typeof TOUR_TONES[number]['id']

const STORAGE_KEY = 'manual-tour-tone'
const DEFAULT_TONE: TourToneId = 'gradient'

/** stg とローカル開発だけ色の切り替えを出す。本番には出さない */
export function isTourToneSwitchEnabled(): boolean {
  return (
    process.env.VUE_APP_ENV === 'stg' || process.env.NODE_ENV === 'development'
  )
}

export function getTourTone(): TourToneId {
  if (!isTourToneSwitchEnabled() || typeof sessionStorage === 'undefined') {
    return DEFAULT_TONE
  }
  const saved = sessionStorage.getItem(STORAGE_KEY)
  const found = TOUR_TONES.find((tone) => tone.id === saved)
  return found ? found.id : DEFAULT_TONE
}

export function tourPopoverClass(): string {
  return `manual-tour-popover tour-tone-${getTourTone()}`
}

/** 開いている吹き出しがあれば、その場で色を差し替える */
export function applyTourTone(toneId: TourToneId): void {
  if (typeof sessionStorage !== 'undefined') {
    sessionStorage.setItem(STORAGE_KEY, toneId)
  }
  const popover = document.querySelector('.manual-tour-popover')
  if (!popover) {
    return
  }
  TOUR_TONES.forEach((tone) => {
    popover.classList.remove(`tour-tone-${tone.id}`)
  })
  popover.classList.add(`tour-tone-${toneId}`)
}
